var tables = $(".apo-row table").not('.clone').each(function () {
  var table = $( this );
  table.removeAttr('style');
});
